<!--
 * @Description: 
 * @Author: zhangben
 * @Date: 2024-08-06 08:55:58
 * @LastEditors: zhangben
 * @LastEditTime: 2024-12-03 16:55:27
-->
<template>
  <!-- <div id="footer"> -->
  <div class="foot">
    <div class="foot_c">
      <div class="logo_f"><img src="@/assets/images/logo_f.gif" /></div>
      <div class="foot_z">
        地址：沈阳市皇姑区黄河南大街60号中建峰汇C座905 电话：13889338803
        15640556662（微信同步） 邮箱：syyibokeji@163.com<br />

        <a
          target="_blank"
          href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=21010502000416"
          style="display:inline-block;text-decoration:none;height:20px;line-height:40px;"
          ><img
            src="@/assets/images/gawba.png"
            style="float:left;margin-top:5px"
          />
          <p
            style="float:left;height:20px;line-height:20px;margin: 5px 0px 0px 5px; color:#000;"
          >
            辽公网安备 21010502000416号
          </p></a
        >

        版权所有 © 沈阳一博科技有限公司
        <a
          href="https://beian.miit.gov.cn/"
          title="ICP"
          target="_blank"
          style="color: #000;"
        >
          <p
            style="float:right;height:20px;line-height:20px;margin: 5px 0px 0px 5px; color:#000;"
          >
            辽ICP备案号：辽ICP备18011178号-1
          </p></a
        >
        <!-- 辽宁华睿科技提供技术支持 -->
      </div>
    </div>
  </div>
  <!-- </div> -->

  <!-- <div id="footer" class="container-fluid" style="display: none;">
    <div class="logo">
      <img src="@/assets/img/yctlogo.png" alt="logo图" />
    </div>
    <p class="title">易齿通（沈阳）医疗科技有限公司</p>
    <p class="address_tel_fax">
      <span>地址：辽宁省沈阳市沈北新区蒲河大道888号 西三区19号楼3层</span>
      <span>Tel：400-114-1200</span>
    </p>
    <p class="email_wx">
     
    </p>
    <p>
      <a
        href="https://beian.miit.gov.cn/#/Integrated/index"
        target="_blank"
        rel="noreferrer"
      >
        辽ICP备2023013010号-1</a
      >
    </p>
    <p class="copy">
      Copyright &copy; 2018 - 2019 易齿通（沈阳）医疗科技有限公司
    </p>
  </div> -->
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {
      softwareList: [
        {
          path: "/software/smartTown",
          name: "企业介绍"
        },
        {
          path: "/software/bigData",
          name: "全国分布"
        },
        {
          path: "/software/history",
          name: "合作伙伴"
        },
        {
          path: "/software/card",
          name: "荣誉资质"
        }
      ],
      softwareList1: [
        {
          path: "/serviceCenter/produce",
          name: "生产企业"
        },
        {
          path: "/serviceCenter/hospital",
          name: "医疗机构"
        },
        {
          path: "/serviceCenter/buy",
          name: "个性化定制"
        }
      ],
      softwareList2: [
        {
          path: "/healthScience/video",
          name: "产品使用视频"
        },
        {
          path: "/healthScience/speciality",
          name: "专业科普"
        }
      ],
      serverList: [
        {
          logo: require("@/assets/img/tel.png"),
          title: "核心优势1",
          content: "<p>由专业客服提供人工服务</p>负责疑难问题和故障受理"
        },
        {
          logo: require("@/assets/img/computer.png"),
          title: "核心优势2",
          content: "<p>利用远程视频工具，提供协助</p>帮助客户进行调试、解决故障"
        },
        {
          logo: require("@/assets/img/qq.png"),
          title: "核心优势3",
          content: "<p>利用企业QQ提供在线解答</p>帮助企业快速准确解决问题和故障"
        },
        {
          logo: require("@/assets/img/skill.png"),
          title: "核心优势4",
          content: "<p>由技术支持工程师，负责问题解答</p>需求受理及故障受理"
        },
        {
          logo: require("@/assets/img/qq.png"),
          title: "核心优势3",
          content: "<p>利用企业QQ提供在线解答</p>帮助企业快速准确解决问题和故障"
        },
        {
          logo: require("@/assets/img/skill.png"),
          title: "核心优势4",
          content: "<p>由技术支持工程师，负责问题解答</p>需求受理及故障受理"
        }
      ]
    };
  },
  methods: {
    onHand(index) {
      console.log(index);
      this.$emit("callBack", index);
    }
  }
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 100%;
  color: #fff;
  background: #009d91;

  overflow: hidden;
  text-align: center;
  padding: 50px;
}
.server-wrapper {
  /* width: 70%; */
  margin: auto;
}
#left {
  margin: 50px 0;
}
.left-container {
  /* width: 60%; */
  margin: 0 auto;
  /* border: 1px solid #000; */
  border-radius: 5px;
}
.left-container > p {
  text-align: center;
  line-height: 45px;
  padding: 0;
  margin: 0;
  background: #009d91;

  color: #fff;
  font-size: 18px;
  font-weight: bold;
}
.left-container > li {
  text-align: center;
  height: 38px;
  line-height: 38px;
  margin: 0;
  /* border-top: 1px solid #000; */
}
.left-container > li > a {
  text-decoration: none;
}
.left-container > li:hover {
  background: #928989;
}
.logo {
  width: 95px;
  height: 45px;
  margin: 50px auto 20px;
}
.title {
  font-size: 25px;
  margin-bottom: 20px;
}
.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0;
}
.email_wx {
  color: #d3d3d3;
  font-size: 14px;
}
.copy {
  color: #d3d3d3;
  font-size: 14px;
  margin: 50px 0 10px;
}
@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }
  .address_tel_fax {
    font-size: 12px;
  }
  .email_wx {
    font-size: 12px;
  }
  .copy {
    font-size: 12px;
    margin: 30px 0 10px;
  }
}
a {
  color: #ffffff !important;
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue